import { fromJS } from 'immutable';
import { findPropertiesByScope } from '@pearsontechnology/aero-plugin-schema';
import { urnToURL } from 'utils/mapUrnToUrl';
import { getSchemaVersion } from '../Schema';

export function composeState(schema, config, scope, assets = []) {
  /* state object based on config  */
  let state = fromJS(config || {});

  /* immutable version of scope to get properties by path */
  const immutableScope = fromJS(scope || {});

  /* definition of scope and config properties from schemas */
  const scopeProperties = findPropertiesByScope(schema);

  /* add scope items to state */
  scopeProperties.forEach(({ path, property }) => {
    const value = immutableScope.getIn(path, state.getIn(path));
    state = (value === undefined)
      ? state.setIn(path, property.default || null)
      : state.setIn(path, value);
  });

  let stateJS = state.toJS();
  if (assets.length) {
    const isV2AssetSchema = getSchemaVersion(schema).major >= 2;
    stateJS = JSON.parse(urnToURL(assets, JSON.stringify(stateJS), isV2AssetSchema));
  }
  return stateJS;
}
